import { render, staticRenderFns } from "./ExemptionPayments.vue?vue&type=template&id=a03ac720&scoped=true"
import script from "./ExemptionPayments.vue?vue&type=script&lang=js"
export * from "./ExemptionPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a03ac720",
  null
  
)

export default component.exports